import { useState, useEffect } from 'react';

interface ProductsProps {
  apiEndpoint: string;
}

interface Product {
  id: number;
  name: string;
  price: number;
  quantity: number;
  sku: string;
  is_active: number;
}

export default function Products({ apiEndpoint }: ProductsProps) {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchProducts();
  }, [apiEndpoint, search]);

  const fetchProducts = async () => {
    try {
      const query = search ? `&search=${encodeURIComponent(search)}` : '';
      const response = await fetch(`${apiEndpoint}/api/sv9/products`, { headers: { 'x-router-secret': import.meta.env.VITE_ROUTER_SECRET } });
      const data = await response.json();
      setProducts(data.products || []);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch products:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>Products</h1>
        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: '10px 16px',
            borderRadius: '8px',
            border: '1px solid #ddd',
            width: '300px'
          }}
        />
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>SKU</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product.id}>
                <td>#{product.id}</td>
                <td>{product.name}</td>
                <td>{product.sku || '-'}</td>
                <td>฿{product.price?.toLocaleString()}</td>
                <td>{product.quantity}</td>
                <td>
                  <span className={`status ${product.is_active ? 'paid' : 'pending'}`}>
                    {product.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
